import { createSaga } from './saga-helpers';

import * as Api from '../api/task-groups-api';

const watchGetTaskGroups = createSaga({
    type: 'TASK_GROUPS_FETCH',
    fn: Api.fetchTaskGroups,
    args: action => [action.payload],
    successPayload: ({ items, hasMore } = {}, action) => ({
        taskGroups: items,
        hasMore,
        ...action.payload
    }),
    errorPayload: (e, action) => ({
        message: e.message || e,
        ...action.payload
    })
});

const watchCreateTaskGroup = createSaga({
    type: 'TASK_GROUP_CREATE',
    fn: Api.createTaskGroup,
    args: action => [action.payload.taskGroup],
    successPayload: (taskGroup, action) => ({
        taskGroup: {
            id: taskGroup.id,
            order: taskGroup.order
        },
        fragment: action.payload.taskGroup
    }),
    errorPayload: (e, action) => ({
        message: e.message || e,
        fragment: action.payload.taskGroup
    })
});

const watchGetTaskGroup = createSaga({
    type: 'TASK_GROUP_FETCH',
    fn: Api.fetchTaskGroup,
    args: action => [action.payload.taskGroupId],
    successPayload: taskGroup => ({ taskGroup }),
    errorPayload: (e, action) => ({
        removed: e === 'Task group not found',
        taskGroupId: action.payload.taskGroupId
    })
});

const watchUpdateTaskGroup = createSaga({
    type: 'TASK_GROUP_UPDATE',
    fn: Api.updateTaskGroup,
    args: action => [action.payload.taskGroupId, action.payload.taskGroupProps],
    successPayload: taskGroup => ({ taskGroup })
});

const watchRemoveTaskGroup = createSaga({
    type: 'TASK_GROUP_REMOVE',
    fn: Api.removeTaskGroup,
    args: action => [action.payload.taskGroupId]
});

const watchAssignUsers = createSaga({
    type: 'TASK_GROUP_ASSIGN',
    fn: Api.assignUsers,
    args: action => [action.payload.taskGroupId, action.payload.assignees]
});

const watchUnassignUsers = createSaga({
    type: 'TASK_GROUP_UNASSIGN',
    fn: Api.unassignUsers,
    args: action => [action.payload.taskGroupId, action.payload.assignees]
});

const watchMoveAllTaskGroupTasks = createSaga({
    type: 'TASK_GROUP_MOVE_ALL_TASKS',
    fn: Api.moveAllTaskGroupTasks,
    args: action => [action.payload.sourceTaskGroupId, action.payload.targetTaskGroupId]
});

const watchSetVisibility = createSaga({
    type: 'TASK_GROUP_VISIBILITY_SET',
    fn: Api.setVisibility,
    args: action => [action.payload.taskGroupId, action.payload.visible, action.payload.roles]
});

export default [watchGetTaskGroups, watchCreateTaskGroup, watchGetTaskGroup, watchUpdateTaskGroup, watchRemoveTaskGroup, watchAssignUsers, watchUnassignUsers, watchMoveAllTaskGroupTasks, watchSetVisibility];
